module.exports = __webpack_public_path__ + "lp/img/menu_icon_light.15581e5c.svg";